import fetch from '../fetch'

let prefix = `${window.env.api_url}/api/untp-enterprise/untp`

// 获取企业列表
export function getEnterpriseList(type, name, pageNum, pageSize) {
  return fetch.get(`${prefix}/enterprise/user/pageEnterprises`, {params: {type, name, pageNum, pageSize}})
}

// 查询所有非企业用户
export function getNoEnterpriseUsers(params) {
  return fetch.get(`${prefix}/enterprise/user/pageNoEnterpriseUsers`, {params})
}

// 查询企业用户
export function getEnterpriseUsersList(params) {
  return fetch.get(`${prefix}/enterprise/user/pageEnterpriseUsers`, {params})
}

// 添加企业用户
export function addUserToEnterprise(enterpriseId, userId) {
  return fetch.post(`${prefix}/enterprise/user/saveEnterpriseUsers?enterpriseId=${enterpriseId}&userId=${userId}`)
}

// 删除企业用户
export function deleteEnterpriseUser(enterpriseUserIds) {
  return fetch.delete(`${prefix}/enterprise/user/removeEnterpriseUsers`, {params: {enterpriseUserIds}})
}

// 查询企业关系类型
export function getRelationTypes() {
  return fetch.get(`${prefix}/enterprise/rela/getRelaTypes`)
}

// 查询企业关系列表
export function getEnterpriseRelaData(params) {
  return fetch.get(`${prefix}/enterprise/rela/pageEnterpriseRoles`, {params})
}

// 取消企业关联关系
export function deleteEnterpriseRelation(enterpriseRelaIds) {
  return fetch.delete(`${prefix}/enterprise/rela/removeEnterpriseRela`, {params: {enterpriseRelaIds}})
}

// 查询未关联企业的列表
export function getNoRelaEnterprise(params) {
  return fetch.get(`${prefix}/enterprise/rela/pageNoRelaEnterprises`, {params})
}

// 添加企业关系
export function saveEnterpriseRelation(masterEnterpriseId, slaveEnterpriseId, relaName) {
  return fetch.post(`${prefix}/enterprise/rela/saveEnterpriseRela?masterEnterpriseId=${masterEnterpriseId}&slaveEnterpriseId=${slaveEnterpriseId}&relaName=${relaName}`)
}

// 根据用户查询企业
export function getEnterpriseInfoByUserId(userId) {
  return fetch.get(`${prefix}/enterprise/user/getEnterpriseByuserId?userId=${userId}`)
}


// 企业列表(过滤主机厂)
export function getFiltrationEnterprises(params) {
  return fetch.get(`${prefix}/enterprise/user/pageFiltrationEnterprises`, {params})
}

// 企业配额列表(过滤主机厂)
export function pageEnterpriseQuota(params) {
  return fetch.get(`${prefix}/enterprise/limit/getEnterpriseLimitList`, {params})
}

// 编辑企业配额
export function editEnterpriseQuota(params){
  return fetch.post(`${prefix}/enterprise/limit/saveOrupdateEnterpriseLimt`, params)
}

// 重置企业配额
export function removeEnterpriseLimit(enterpriseLimitIds){
  return fetch.delete(`${prefix}/enterprise/limit/removeEnterpriseLimit`, {params: {enterpriseLimitIds}})
}

// 企业添加工厂
export function insterEntFactory(params){
  return fetch.post(`${prefix}/enterprise/user/insterEntFactory`, params)
}
//企业工厂列表
export function pageEntFactorys(params) {
  return fetch.get(`${prefix}/enterprise/user/pageEntFactorys`, {params})
}

// 更新工厂
export function updateEntFactoryInfo(params) {
  return fetch.put(`${prefix}/enterprise/user/updateEntFactoryInfo`, params)
}

// 删除企业工厂
export function removeEntFactorys(params) {
  return fetch.delete(`${prefix}/enterprise/user/removeEntFactorys`, {params})
}

// 查询企业内非工厂用户
export function pageUnboundFacUser(params) {
  return fetch.get(`${prefix}/enterprise/user/pageUnboundFacUser`, {params})
}

// 获取企业列表
export function getAuthInfos(params) {
    return fetch.get(`${prefix}/enterprise/user/getAuthInfos`, {params})
}
